<template>
  <main class="mobile-app-gate">
    <div class="mobile-app-gate__glow mobile-app-gate__glow--yellow"/>
    <div class="mobile-app-gate__glow mobile-app-gate__glow--green"/>

    <section class="mobile-app-gate__card" aria-labelledby="mobile-app-title">
      <img class="mobile-app-gate__logo" src="@/assets/agrologo.png" alt="Agrostream">

      <h1 id="mobile-app-title">Agrostream Lite</h1>
      <p class="mobile-app-gate__description">
        Мониторинг техники, поля, задачи и отчёты — в приложении, созданном для работы с телефона.
      </p>

      <p v-if="deepLink" class="mobile-app-gate__hint">
        Если приложение не открылось, установите его из магазина.
      </p>
      <p v-else class="mobile-app-gate__hint">
        Выберите магазин для установки приложения.
      </p>

      <div class="mobile-app-gate__stores" aria-label="Ссылки на магазины приложений">
        <a class="mobile-app-gate__store" :href="iosStoreUrl" aria-label="Скачать Agrostream Lite в App Store">
          <svg aria-hidden="true" viewBox="0 0 24 24">
            <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.79 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.53 4.1ZM12.03 7.25C11.88 5.02 13.69 3.18 15.77 3c.29 2.58-2.34 4.5-3.74 4.25Z"/>
          </svg>
          <span>
            <small>Загрузить в</small>
            <strong>App Store</strong>
          </span>
        </a>

        <a class="mobile-app-gate__store" :href="androidStoreUrl" aria-label="Скачать Agrostream Lite в Google Play">
          <svg aria-hidden="true" viewBox="0 0 24 24">
            <path d="M3.6 2.7 14.7 12 3.6 21.3a2 2 0 0 1-.6-1.5V4.2a2 2 0 0 1 .6-1.5Zm12.3 10.4 2.7 2.3L6 22.5l9.9-9.4Zm3.9-4.4c.8.4 1.2 1 1.2 1.6 0 .7-.4 1.2-1.2 1.7l-2.5 1.4-2.9-2.4 2.9-2.4 2.5 1.1ZM6 1.5l12.6 7.1-2.7 2.3L6 1.5Z"/>
          </svg>
          <span>
            <small>Доступно в</small>
            <strong>Google Play</strong>
          </span>
        </a>
      </div>

    </section>

    <p class="mobile-app-gate__footer">AGROSTREAM · INFORMATION TECHNOLOGY</p>
  </main>
</template>

<script>
import {getMobileAppConfig} from "@/services/mobile-app"

export default {
  name: "MobileAppGate",
  data() {
    const config = getMobileAppConfig()
    config.openTimer = null
    return config
  },
  mounted() {
    if (!this.deepLink) {
      return
    }

    this.openTimer = window.setTimeout(() => {
      window.location.assign(this.deepLink)
    }, 300)
  },
  beforeUnmount() {
    window.clearTimeout(this.openTimer)
  },
}
</script>

<style lang="scss" scoped>
.mobile-app-gate {
  --gate-yellow: #fbb138;
  --gate-green: #a9c93f;
  position: relative;
  display: grid;
  min-height: 100vh;
  min-height: 100dvh;
  box-sizing: border-box;
  place-items: center;
  overflow: hidden;
  padding: max(28px, env(safe-area-inset-top)) 20px max(22px, env(safe-area-inset-bottom));
  color: #263238;
  background:
    linear-gradient(rgba(255, 255, 255, 0.94), rgba(248, 250, 244, 0.98)),
    repeating-linear-gradient(115deg, transparent 0 42px, rgba(169, 201, 63, 0.1) 43px 44px);
}

.mobile-app-gate__glow {
  position: absolute;
  width: 260px;
  height: 260px;
  border-radius: 50%;
  filter: blur(4px);
  opacity: 0.2;
  pointer-events: none;
}

.mobile-app-gate__glow--yellow {
  top: -120px;
  right: -100px;
  background: var(--gate-yellow);
}

.mobile-app-gate__glow--green {
  bottom: -140px;
  left: -120px;
  background: var(--gate-green);
}

.mobile-app-gate__card {
  z-index: 1;
  width: min(100%, 420px);
  box-sizing: border-box;
  padding: 30px 24px 26px;
  text-align: center;
  border: 1px solid rgba(47, 63, 46, 0.08);
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 24px 70px rgba(44, 57, 43, 0.14);
  backdrop-filter: blur(12px);
}

.mobile-app-gate__logo {
  display: block;
  width: min(235px, 74%);
  height: auto;
  margin: 0 auto 30px;
}

.mobile-app-gate h1 {
  margin: 0;
  color: #26302e;
  font-size: clamp(28px, 8vw, 36px);
  font-weight: 750;
  letter-spacing: -0.04em;
}

.mobile-app-gate__description {
  max-width: 330px;
  margin: 13px auto 24px;
  color: #66716f;
  font-size: 15px;
  line-height: 1.55;
}

.mobile-app-gate__hint {
  margin: 0 0 12px;
  color: #89918f;
  font-size: 12px;
  line-height: 1.4;
}

.mobile-app-gate__stores {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.mobile-app-gate__store {
  display: flex;
  min-height: 52px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 10px;
  color: #fff;
  text-align: left;
  text-decoration: none;
  border-radius: 13px;
  background: #17201e;
}

.mobile-app-gate__store:hover,
.mobile-app-gate__store:focus {
  color: #fff;
}

.mobile-app-gate__store small,
.mobile-app-gate__store strong {
  display: block;
  white-space: nowrap;
}

.mobile-app-gate__store small {
  margin-bottom: 1px;
  font-size: 9px;
  font-weight: 400;
  opacity: 0.72;
}

.mobile-app-gate__store strong {
  font-size: 13px;
  line-height: 1;
}

.mobile-app-gate__store svg {
  width: 22px;
  height: 22px;
  fill: #fff;
}

.mobile-app-gate__footer {
  z-index: 1;
  align-self: end;
  margin: 22px 0 0;
  color: #99a19f;
  font-size: 9px;
  letter-spacing: 0.13em;
}

@media (max-width: 370px), (max-height: 680px) {
  .mobile-app-gate {
    padding-top: 14px;
    padding-bottom: 14px;
  }

  .mobile-app-gate__card {
    padding: 22px 18px 18px;
    border-radius: 22px;
  }

  .mobile-app-gate__logo {
    margin-bottom: 18px;
  }

  .mobile-app-gate__description {
    margin-bottom: 17px;
    font-size: 14px;
  }

  .mobile-app-gate__footer {
    display: none;
  }
}
</style>
